import React, { Component } from 'react';
import native from 'c-up-native';

class Mlink extends Component {
    constructor(props) {
        super(props);
    }
    openNewView(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        native.openWebView({
            url: this.props.href,
            errtip: function() {
                alert('不支持');
            }
        });
    }
    render() {
        const isUplive = native.getPlatform() == 'uplive';
        let el;
        if (isUplive) {
            el = <a href="#" onClick={ e => this.openNewView(e) }>{ this.props.children }</a>;
        } else {
            el = <a {...this.props}>{ this.props.children }</a>;
        }

        return el;
    }
}

export default Mlink;



// WEBPACK FOOTER //
// ./js/components/mlink.js